<div class="page">
  <header class="hero">
    <p class="eyebrow">ניהול קטלוג</p>
    <h1>בדיקת יחידות</h1>
    <p class="lede">
      שורות שבהן הגודל בשם המוצר סותר את Quantity/UnitQty בפיד. אישור כותב את היחידה
      מהשם למוצר ונועל אותה מפני העלאה הבאה.
    </p>
  </header>

  @if (errorMessage) {
    <p class="error" role="alert">{{ errorMessage }}</p>
  }

  <div class="filters" role="tablist" aria-label="סטטוס בדיקה">
    @for (option of statuses; track option.id) {
      <button
        type="button"
        role="tab"
        [class.active]="status === option.id"
        [attr.aria-selected]="status === option.id"
        [attr.data-testid]="'unit-review-status-' + option.id"
        (click)="load(option.id)"
      >
        {{ option.label }}
      </button>
    }
  </div>

  @if (loading) {
    <p class="muted">טוען…</p>
  } @else if (items.length === 0) {
    <p class="muted">אין שורות בסטטוס הזה.</p>
  } @else {
    <p class="count">{{ items.length }} שורות</p>
    <ul class="review-list">
      @for (item of items; track item.id) {
        <li
          class="card"
          [class.leaving]="leavingId === item.id"
          [attr.data-testid]="'unit-review-' + item.id"
        >
          <div class="card-top">
            <div>
              <h2 dir="auto">{{ item.nameRaw }}</h2>
              <p class="meta">
                @if (item.chainName) {
                  <span>רשת {{ item.chainName }}</span>
                }
                @if (item.branchName) {
                  <span>סניף {{ item.branchName }}</span>
                }
                @if (item.barcode) {
                  <span>ברקוד {{ item.barcode }}</span>
                }
                @if (item.itemCode && item.itemCode !== item.barcode) {
                  <span>קוד {{ item.itemCode }}</span>
                }
                <span>{{ reasonLabel(item.reason) }}</span>
                @if (item.qtyMatchesNameSize) {
                  <span class="badge">המספר בשם תואם לכמות בפיד</span>
                }
              </p>
            </div>
          </div>

          <dl class="diff">
            <div>
              <dt>מוצג עכשיו</dt>
              <dd dir="auto" class="current">{{ item.currentDisplayName }}</dd>
            </div>
            <div>
              <dt>מוצע אחרי תיקון</dt>
              <dd dir="auto" class="proposed">{{ item.proposedDisplayName || 'אין הצעה' }}</dd>
            </div>
            <div>
              <dt>פיד</dt>
              <dd dir="auto">{{ item.feedSize }} {{ item.feedUnit }}</dd>
            </div>
            <div>
              <dt>מהשם</dt>
              <dd dir="auto">{{ item.nameSize }} {{ item.nameUnit }}</dd>
            </div>
          </dl>

          @if (item.latestSource) {
            <p class="source" dir="ltr">{{ item.latestSource }}</p>
          }

          <div class="actions">
            <button
              type="button"
              data-testid="unit-review-load-xml"
              [disabled]="busyId === item.id"
              (click)="loadXml(item)"
            >
              טען XML
            </button>
            @if (xmlFor(item.id); as xml) {
              <button type="button" (click)="toggleXml(item)">
                {{ xmlOpenId === item.id ? 'הסתר XML' : 'הצג XML' }}
              </button>
            }
            @if (item.status === 'pending') {
              <button
                type="button"
                class="apply"
                data-testid="unit-review-apply"
                [disabled]="busyId !== null || !item.proposedDisplayName"
                (click)="apply(item)"
              >
                אשר תיקון
              </button>
              <button
                type="button"
                class="dismiss"
                data-testid="unit-review-dismiss"
                [disabled]="busyId !== null"
                (click)="dismiss(item)"
              >
                דחה
              </button>
            }
          </div>

          @if (xmlOpenId === item.id) {
            @if (xmlFor(item.id); as xml) {
              @if (xml.found && xml.xml) {
                <pre class="xml" dir="ltr">{{ xml.xml }}</pre>
              } @else {
                <p class="muted">{{ missingLabel(xml.missingReason) }}</p>
              }
            }
          }
        </li>
      }
    </ul>
  }
</div>
